import React, { useState, useContext, useEffect } from "react";
import desktopIcon from "../../assets/images/desktopIcon.png";
import starIcon from "../../assets/images/star.png";
import redFlag from "../../assets/images/redFlag.png";
import { AuthContext } from "../../context/AuthContext";

function TherapyRoomCard({
  room,
  isSelected,
  onSelect,
  onEnterClick,
  sessions = [],
  selectedTherapyType,
  preloadState,

  // ✅ NEW (safe defaults so normal rooms unaffected)
  aiLockLoading = false,
  isAILocked = false,
}) {

  const [isHovered, setIsHovered] = useState(false);
  const [isStarHovered, setIsStarHovered] = useState(false);
  const [selectedSession, setSelectedSession] = useState(
    sessions.find((s) => s.isAvailable || s.isUpcoming) || null
  );
  useEffect(() => {
    const newSelectedSession =
      sessions.find((s) => s.isAvailable || s.isUpcoming) || null;
    setSelectedSession(newSelectedSession);
  }, [sessions]);
  const primarySession = sessions.find((s) => s.isPrimary) || null;
  const filteredSessions = sessions.filter(
    (s) => s.isAvailable || s.isUpcoming
  );
  const { userType } = useContext(AuthContext);

  const {
    image,
    title,
    description,
    accessibility,
    style,
    available,
    isComingSoon,
    online,
  } = room;

  const parts = accessibility?.trim().split(" ") || [];
const last = parts.pop();
const rest = parts.join(" ");

  const isAI = selectedTherapyType === "ai";
  const isPreloading = ["queued", "loading"].includes(preloadState?.status);
  const preloadProgress = Math.round((preloadState?.progress || 0) * 100);
  // AI buttons remain disabled until their lock status is known and unlocked.
  const aiDisabled = isAI && (aiLockLoading || isAILocked);
  const canEnter = selectedTherapyType === "ai"
    ? available && !aiDisabled
    : available && filteredSessions.length > 0;



  return (
    <div
      className={`bg-black text-white rounded-3xl shadow-lg p-6 flex flex-col mx-auto w-full max-w-[350px] md:max-w-[450px] lg:max-w-[572px] h-auto transition-shadow duration-300 border-[4px] cursor-pointer ${
  isComingSoon
  ? isHovered
    ? "cursor-not-allowed border-[4px] border-transparent [background:linear-gradient(#000,#000)_padding-box,linear-gradient(90deg,#8B5CF6,#4C1D95,#00F5D4)_border-box] shadow-[0_0_35px_rgba(0,245,212,0.45)]"
    : "cursor-not-allowed border-[4px] border-transparent"
    : isSelected
    ? "border-[#22AAEE]"
    : isHovered
    ? "border-[#22AAEE]"
    : "border-transparent"
}`}
      style={{
        position: "relative",
        overflow: "visible",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onSelect}
    >
      {isSelected && (
        <div
          className="absolute top-0 left-0 z-20"
          style={{ transform: "translate(-45%, -65%)" }}
          onMouseEnter={() => setIsStarHovered(true)}
          onMouseLeave={() => setIsStarHovered(false)}
        >
          <img src={starIcon} alt="Selected" className="w-13 h-12" />
          {isStarHovered && (
            <span
              className="absolute bg-white text-black text-xs px-2 py-2 rounded-xl shadow-lg"
              style={{ top: "-20px", left: "80%", zIndex: 30 }}
            >
              {userType === "Client"
                ? "Your preferred space"
                : "Client's preferred space"}
            </span>
          )}
        </div>
      )}

      <div
        className="relative w-full h-64 rounded-lg mb-4 overflow-hidden group/preload"
        tabIndex={isPreloading ? 0 : undefined}
      >
        <img
          src={image}
          alt={title}
          className={`absolute inset-0 w-full h-full object-cover ${isPreloading ? "grayscale" : ""}`}
        />
        {isPreloading && (
          <>
            <img
              src={image}
              alt=""
              className="absolute inset-0 w-full h-full object-cover transition-[clip-path] duration-200 ease-out"
              style={{ clipPath: `inset(0 ${100 - preloadProgress}% 0 0)` }}
              aria-hidden="true"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/20">
              <span className="rounded-full bg-black/75 px-4 py-2 text-sm font-semibold text-white shadow-lg">
                {preloadState.status === "queued"
                  ? "Waiting to preload…"
                  : `Preloading… ${preloadProgress}%`}
              </span>
            </div>
            <div
              role="tooltip"
              className="pointer-events-none absolute left-1/2 top-1/2 z-30 hidden w-[min(90%,320px)] -translate-x-1/2 translate-y-8 rounded-xl bg-white px-4 py-3 text-center text-xs font-medium leading-relaxed text-black shadow-xl group-hover/preload:block group-focus-within/preload:block"
            >
              Stay on this page while your space preloads so your session opens faster.
              {canEnter ? " You can enter now while preloading continues." : ""}
            </div>
          </>
        )}
      </div>

      <div className="mb-4" style={{ minHeight: "120px" }}>
        <h3
          className="font-medium mb-2"
          style={{ fontSize: "var(--font-size-title)" }}
        >
          {title}
        </h3>
        <p
          className="font-medium"
          style={{ fontSize: "var(--font-size-description)" }}
        >
          {description}
        </p>
      </div>

      <div style={{ minHeight: "100px" }}>
        {/* <p
          className="font-medium mb-2 flex items-center"
          style={{ fontSize: "var(--font-size-description)" }}
        >
          Current Accessibility | {accessibility}
          <span className="inline-flex items-center ml-2">
            <img
              src={desktopIcon}
              alt="Accessibility Icon"
              className="w-[18px] h-[18px]"
            />
          </span>
        </p> */}


<p
  className="font-medium mb-2 leading-snug"
  style={{ fontSize: "var(--font-size-description)" }}
>
  Current Accessibility | {rest}
  <span className="inline-flex items-center whitespace-nowrap">
    &nbsp;{last}
    <img
      src={desktopIcon}
      alt="Accessibility Icon"
      className="w-[16px] h-[16px] ml-1 inline-block"
      style={{ flexShrink: 0 }}
    />
  </span>
</p>






        <p
          className="font-medium mb-2"
          style={{ fontSize: "var(--font-size-description)" }}
        >
          Virtual Space Style | {style}
        </p>
        {selectedTherapyType !== "ai" &&
          selectedSession?.sessionStartTimeEST && (
            <p
              className="font-medium text-[#22AAEE] mt-2"
              style={{ fontSize: "var(--font-size-description)" }}
            >
              Session Start Time: {selectedSession.sessionStartTimeEST}
            </p>
          )}
      </div>

      <div className="w-full flex flex-col justify-center mt-2 w-full max-w-[350px] md:max-w-[450px] lg:max-w-[500px] mx-auto">
        {selectedTherapyType === "ai" && available ? (
          <button
            disabled={aiDisabled}
            onClick={() => {
              if (aiDisabled) return;
              onEnterClick();
            }}
            className={`w-full font-semibold rounded-full px-6 py-3 text-sm md:text-base transition duration-300 shadow-md
              ${
                aiDisabled
                  ? "bg-gray-500 text-white cursor-not-allowed"
                  : "bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white"
              }`}
          >
            ENTER
          </button>
        ) : available && filteredSessions.length > 0 ? (
          filteredSessions.length === 1 ? (
            <button
              onClick={() => onEnterClick(filteredSessions[0].meetingID)}
              className="w-full font-semibold rounded-full px-6 py-3 text-sm md:text-base bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white transition duration-300 shadow-md"
            >
              ENTER
            </button>
          ) : (
            <>
              {selectedTherapyType !== "ai" && (
                <>
                  {" "}
                  <label
                    htmlFor="sessionSelect"
                    className="text-sm text-white mb-2 font-medium"
                  >
                    Select a Session
                  </label>
                  <select
                    id="sessionSelect"
                    value={
                      selectedSession?.meetingID ||
                      filteredSessions[0]?.meetingID ||
                      ""
                    }
                    onChange={(e) => {
                      const selected = filteredSessions.find(
                        (s) => s.meetingID === e.target.value
                      );
                      setSelectedSession(selected || null);
                    }}
                    className="w-full rounded-lg border border-[#22AAEE] bg-white text-black px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#22AAEE] transition duration-200 shadow-sm"
                  >
                    <optgroup label="Available Sessions">
                      {filteredSessions.map((session) => (
                        <option
                          key={session.meetingID}
                          value={session.meetingID}
                        >
                          {session.sessionStartTimeEST}
                        </option>
                      ))}
                    </optgroup>
                  </select>
                </>
              )}

              <button
                onClick={() =>
                  onEnterClick(
                    selectedSession?.meetingID || filteredSessions[0]?.meetingID
                  )
                }
                className="mt-4 w-full font-semibold rounded-full px-6 py-3 text-sm md:text-base bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white transition duration-300 shadow-md"
              >
                ENTER
              </button>
            </>
          )
) : (
  <>
    <button
      disabled
      className={`font-semibold rounded-full w-full px-6 py-3 text-sm md:text-base cursor-not-allowed shadow-sm
        ${
          room.sessionStartTimeEST === "Restricted Access"
            ? "bg-gray-500 text-white"
            : "bg-gray-500 text-white"
        }`}
    >
      {isComingSoon ? (
        "Coming Summer 2026"
      ) : room.sessionStartTimeEST === "Restricted Access" ? (
        <span className="flex items-center justify-center gap-2">
          <img
            src={redFlag}
            alt="Restricted Access"
            className="w-8 h-8 inline-block"
          />
          Restricted Access
        </span>
      ) : (
        "Unavailable"
      )}
    </button>

    {room.sessionStartTimeEST === "Restricted Access" && (
      <p className="mt-3 text-sm text-red-200 text-center leading-snug max-w-md mx-auto">
        Access restricted. This space is currently unavailable due to previous
        flagged issues in your conversations. Please contact support if you
        believe this is an error.
      </p>
    )}
  </>
)
}
      </div>
    </div>
  );
}

export default TherapyRoomCard;
